import CryptoJS from 'crypto-js'
import Buffer from 'buffer'

const base64UrlEncoder = (buffer: ArrayBuffer) => {
  const uint8 = new Uint8Array(buffer)
  // eslint-disable-next-line no-use-before-define
  const base64 = fromByteArray(uint8)
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// base64 from byte array
const fromByteArray = (bytes: Uint8Array) => {
  const base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  let result = ''
  let i
  for (i = 0; i + 2 < bytes.length; i += 3) {
    // eslint-disable-next-line no-bitwise
    result += base64Chars[bytes[i] >> 2]
    // eslint-disable-next-line no-bitwise
    result += base64Chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)]
    // eslint-disable-next-line no-bitwise
    result += base64Chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)]
    // eslint-disable-next-line no-bitwise
    result += base64Chars[bytes[i + 2] & 63]
  }
  if (i < bytes.length) {
    // eslint-disable-next-line no-bitwise
    result += base64Chars[bytes[i] >> 2]
    if (i === bytes.length - 1) {
      // eslint-disable-next-line no-bitwise
      result += base64Chars[(bytes[i] & 3) << 4]
      result += '=='
    } else {
      // eslint-disable-next-line no-bitwise
      result += base64Chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)]
      // eslint-disable-next-line no-bitwise
      result += base64Chars[(bytes[i + 1] & 15) << 2]
      result += '='
    }
  }
  return result
}

export const generateCodeVerifier = (length = 128) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  let result = ''
  const values = new Uint8Array(length)
  crypto.getRandomValues(values)
  for (let i = 0; i < length; i++) {
    result += charset[values[i] % charset.length]
  }
  return result
}

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const data = new TextEncoder().encode(verifier)
  // const digest = CryptoJS.SHA256(`${data}`).toString(CryptoJS.enc.Hex)
  const digest = await crypto.subtle.digest('SHA-256', data)
  console.log('digest', digest)
  return base64UrlEncoder(digest)
}